
$(document).ready(function(){
  $('img[src="//tokinjew.com/cdn/shop/files/MG_1195.jpg?v=1720826736&width=2000"]').attr('alt', 'joint scroller');
$('img[src^="//tokinjew.com/cdn/shop/files/f3d7c255-6071-4b03-9692-932234b1f59e.png"]').attr('alt', 'matzo rolling papers');
$('img[src^="//tokinjew.com/cdn/shop/files/7EEDAF8C-4FE4-4695-BDD5-B20CB7EF1512.png"]').attr('alt', 'Tokin’ Jew Star of David Rolling Papers');
$('img[src="//tokinjew.com/cdn/shop/files/1DEF9EB6-5454-4D94-AE23-3FD07C006C70.png?v=1724187201&width=2000"]').attr('alt', 'shofar pipe');
$('img[src="//tokinjew.com/cdn/shop/files/MG_1248.jpg?v=1720828717&width=2000"]').attr('alt', 'menorah bong');
$('img[src="//tokinjew.com/cdn/shop/files/MG_1147.jpg?v=1720827910&width=2000"]').attr('alt', 'matzah tray');
$('img[src="//tokinjew.com/cdn/shop/files/Holy_Smoker_photoshoot_edited_v01.png?v=1726847203&width=2000"]').attr('alt', 'the holy smoker');
$('img[src="//tokinjew.com/cdn/shop/files/MG_1173_2c68504a-9875-4c0c-8503-315337b8d2fa.jpg?v=1720831964&width=2000"]').attr('alt', 'though shalt');
  $('img[src="//tokinjew.com/cdn/shop/files/MG_1189_1.jpg?v=1732150290&width=2000"]').attr('alt', 'dridel grinder');
$('img[src="//tokinjew.com/cdn/shop/files/MG_1323_746baddd-05eb-4bf1-9572-ca668d55f9e2.jpg?v=1720826968&width=2000"]').attr('alt', 'L chaim tye dye tshirt');
$('img[src="//tokinjew.com/cdn/shop/files/MG_1328.jpg?v=1720827428&width=2000"]').attr('alt', 'Lets get chai tshirt');
$('img[src^="//tokinjew.com/cdn/shop/files/MG_1175.jpg?crop=region"]').attr('alt', 'tokin jew lighter');
$('img[src="//tokinjew.com/cdn/shop/files/MG_1334.jpg?v=1720832619&width=2000"]').attr('alt', 'tokin jew shirt in black color with man photo on front');
$('img[src^="//tokinjew.com/cdn/shop/files/80FA96AA-D106-4A14-B2CF-37BF1ADD25B4.jpg?crop=region"]').attr('alt', 'tokin jew shirt in white color with man photo on front');
$('a.filter-shade').attr('aria-label', 'Select Filter');
  $("h2:empty").append("<span style='display:none'>.</span>")
  $("h6:empty").append("<span style='display:none'>.</span>")
  setTimeout(function(){

  $('img[src="https://d3k81ch9hvuctc.cloudfront.net/company/UwkKi3/images/2fd73563-cd70-49ad-a281-b92185476c08.jpeg"]').attr('alt', 'Men wearing Tokinjew t-shirt and testing Tokinjew products');
},1000)

  
  
  
$('img[src="https://cdn.shopify.com/s/files/1/0550/3867/3149/files/bundle_pack_v1.png?v=1742435430"]').attr('alt', 'Tokinchew bundle pack');
$("#shopify-section-template--18304030540029__main > div.article.article--main > div > div.rte.cf.spaced-row > h2:nth-child(22)").append("<span style='display:none'>.</span>");

$("#shopify-section-template--18304030540029__main > div.article.article--main > div > div.rte.cf.spaced-row > h2:nth-child(37)").append("<span style='display:none'>.</span>");
  $('img[src="https://cdn.shopify.com/s/files/1/0550/3867/3149/files/tokin_jew_megillah_1.png?v=1740700032"]').attr('alt', 'Tokin Jew Megillah scroll illustration');

$('img[src="https://cdn.shopify.com/s/files/1/0550/3867/3149/files/tokin_jew_megillah_2.png?v=1740700114"]').attr('alt', 'King giving order');

$('img[src="https://cdn.shopify.com/s/files/1/0550/3867/3149/files/3_8390e3dc-2173-44a8-9f96-ee10932ce116.png?v=1740706038"]').attr('alt', 'Animated cartoon man checking fam group on phone');
$('img[src="https://cdn.shopify.com/s/files/1/0550/3867/3149/files/4_0a984c20-8fb9-4b25-9cee-48cefec33bbe.png?v=1740707057"]').attr('alt', 'King talking with his queen');
$('img[src="https://cdn.shopify.com/s/files/1/0550/3867/3149/files/6_d5a9dd9e-bf5a-4169-beba-75d0c3f4c5ff.png?v=1740707087"]').attr('alt', 'King having meeting with ministers');
$('img[src="https://cdn.shopify.com/s/files/1/0550/3867/3149/files/5_6b4656ca-25d1-45e8-ad0d-45c97ffbf5aa.png?v=1740707073"]').attr('alt', 'King having food');
$('img[src="https://cdn.shopify.com/s/files/1/0550/3867/3149/files/7.png?v=1740707105"]').attr('alt', 'Man getting angry on other man');
$('img[src="https://cdn.shopify.com/s/files/1/0550/3867/3149/files/9.png?v=1740707148"]').attr('alt', 'People celebrating');
$('img[src="//tokinjew.com/cdn/shop/files/IMG_1902_2.heic?crop=region&crop_height=3024&crop_left=0&crop_top=325&crop_width=3024&v=1723819183&width=3024"]').attr('alt', 'Manischitfaced Tank Top');
$('img[src="//tokinjew.com/cdn/shop/files/MG_1308.jpg?v=1720831619&width=2000"]').attr('alt', 'The Highgada');
$('img[src="//tokinjew.com/cdn/shop/files/MG_1226.jpg?v=1720828045&width=2000"]').attr('alt', 'Matzo Ball Snoop Ball');
$('img[src^="//tokinjew.com/cdn/shop/files/MG_1163.jpg?crop=region&crop_height=2000&crop_left=0&crop_top=0&crop_width=2000&v=1720828222&width=2000"]').attr('alt', 'Matzo Ball Snoop Grinder - Downloadable eBook');
$('img[src="//tokinjew.com/cdn/shop/files/MG_1183.jpg?v=1720830680&width=2000"]').attr('alt', 'Sedar Plate Tray');
$('img[src="//tokinjew.com/cdn/shop/files/MG_1282.jpg?v=1720827068&width=2000"]').attr('alt', 'Let Me Grow Hat');
$('img[src="//tokinjew.com/cdn/shop/files/Hat_15.jpg?v=1723318253&width=3018"]').attr('alt', 'Baruch Atah High Hat');
$('img[src="//tokinjew.com/cdn/shop/files/MG_1260.jpg?v=1720820403&width=2000"]').attr('alt', 'Baked Challah Cover');
$('img[src="//tokinjew.com/cdn/shop/files/MG_1191.jpg?v=1742164137&width=2000"]').attr('alt', 'J Menorah');
$('img[src="//tokinjew.com/cdn/shop/files/MG_1236_1.jpg?crop=region&crop_height=2000&crop_left=0&crop_top=0&crop_width=2000&v=1720825175&width=2000"]').attr('alt', 'Hanukkah Rolling Paper');
$('img[src="//tokinjew.com/cdn/shop/files/MG_1169.jpg?v=1720818950&width=2000"]').attr('alt', '9 Pre-Roll Rainbow Candles');
$('img[src="//tokinjew.com/cdn/shop/files/IMG_5311.jpg?v=1756954008&width=2316"]').attr('alt', 'A person wearing a light-colored cap with text on it, exhaling smoke.');

$('img[src="//tokinjew.com/cdn/shop/files/honey_bottle_closeup_new_earth_v1.png?v=1755635972&width=1239"]').attr('alt', 'A person with a long beard wearing a suit, holding a Tokin Jew High Honey bottle and a pipe.');

$('img[src="//tokinjew.com/cdn/shop/files/TJ_Olympus-11_b4efadbf-0a15-47a7-a758-6f2eb30f7075.jpg?v=1756332084&width=1500"]').attr('alt', 'A person holding pickle pipe.');

$('img[src="//tokinjew.com/cdn/shop/files/IMG_8563.heic?crop=region&crop_height=3024&crop_left=0&crop_top=504&crop_width=3024&v=1725583363&width=3024"]').attr('alt', 'Hand holding a flatbread with lettuce, radish slices, spread, and orange garnish.');

$('img[src="//tokinjew.com/cdn/shop/files/preview_images/24a756967176477991c6911ebf629b3c.thumbnail.0000000000_small.jpg?v=1758033889"]').attr('alt', 'Preview image of Tokin Jew product.');

$('img[src="https://d3k81ch9hvuctc.cloudfront.net/company/UwkKi3/images/2fd73563-cd70-49ad-a281-b92185476c08.jpeg"]').attr('alt', 'Person in a deli using a bong at a table with bagel sandwich, gefilte fish, soup, and latkes.');
$('input[name="contact[email]"]').attr('aria-label', 'Enter your email');
$('span.c-emoji.c-emoji__medium.c-emoji--inline[data-qa="emoji"][data-sk="tooltip_parent"]').removeAttr('aria-describedby');
$('span.c-message__edited_label[dir="ltr"][data-sk="tooltip_parent"]').removeAttr('aria-describedby');

$("img[src=\"//tokinjew.com/cdn/shop/files/resized_1.png?v=1757014954&width=1200\"]").attr("alt", "Forbes article A Jewish Cannabis Brand Finds Its Voice");
   
    $("img[src=\"//tokinjew.com/cdn/shop/files/resized_2.png?v=1757014954&width=1200\"]").attr("alt", "Kosher-for-Passover Tokin\' Jew edibles as orange slices with cannabis leaves on pink background");
   
    $("img[src=\"//tokinjew.com/cdn/shop/files/resized_3.png?v=1757014930&width=1200\"]").attr("alt", "Haaretz article on Tokin\' Jew\'s kosher Passover cannabis edible");
   
    $("img[src=\"//tokinjew.com/cdn/shop/files/resized_4.png?v=1757014952&width=1200\"]").attr("alt", "TrendHunter article on Tokin\' Chews kosher Passover gummies packs");
   
    $("img[src=\"//tokinjew.com/cdn/shop/files/resized_5.png?v=1757014952&width=1200\"]").attr("alt", "Jerusalem Post article on kosher-for-Passover THC gummies by Tokin\' Chews");
   
    $("img[src=\"//tokinjew.com/cdn/shop/files/resized_6.png?v=1757014952&width=1200\"]").attr("alt", "Forward article: Kosher cannabis gummies with rabbi\'s seal, featuring Tokin\' Jew Chews products");
   
    $("img[src=\"//tokinjew.com/cdn/shop/files/resized_7.png?v=1757014953&width=1200\"]").attr("alt", "Jewish Standard article on YIVO\'s \'Am Yisrael High\'");
$("img[src='//tokinjew.com/cdn/shop/files/IMG_8330.jpg?v=1750620259&width=1542']").attr("alt", "Tokin Jew store");


setTimeout(function(){
  $("div.product-label-container span.product-label.product-label--sale>span").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });
$('.product-block').each(function () {
  var block = $(this);
  var altText = block.find('.product-block__title').text().trim();

  block.find('img').each(function () {
    var img = $(this);
    var hasAlt = img.attr('alt');

    if (typeof hasAlt === 'undefined' || hasAlt.trim() === '') {
      img.attr('alt', altText);
    }
  });
});

  $("span.product-label.product-label--new-in>span").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });
 $("div.rapi-bundles__bar-most-popular__content").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });
  
$('carousel-slider.carousel.block.thumbnails ul.slider__grid > li.slider__item > a img').each(function() {
    if (!$(this).attr('alt') || $(this).attr('alt').trim() === '') {
        $(this).attr('alt', 'product images');
    }
});

$("img[src*='thumbnail.0000000000_small.jpg']").attr("alt","thumbnail image");  
},1000)
  $("div.size-table-wrapper th:empty").append("<span style='display:none'>.</span>")
$('img[src="//tokinjew.com/cdn/shop/files/gelt_n_gummies.jpg?v=1733458623&width=1200"]').attr('alt', 'gelt n gummies');
$('img[src="//tokinjew.com/cdn/shop/files/MG_0877_ea786574-fdf1-4ee7-9d4d-8ce288ddb548.jpg?crop=region&crop_height=1466&crop_left=0&crop_top=91&crop_width=1100&v=1721620401&width=1100"]').attr('alt', 'gelt n gummies packaging');
$('img[src="//tokinjew.com/cdn/shop/files/TJ_Olympus-17.jpg?v=1720827117&width=1500"]').attr('alt', 'Person wearing gelt slut tshirt and smiling');
$('img[src="//tokinjew.com/cdn/shop/files/TJ_Olympus-11.jpg?crop=region&crop_height=1466&crop_left=0&crop_top=0&crop_width=1100&v=1721620400&width=1100"]').attr('alt', 'tokin jew product packaging');
$('img[src="//tokinjew.com/cdn/shop/files/TOKIN_JEW8848Capture_v3_2d4d533e-7a73-4081-a557-81cf8aa7f9f3.jpg?v=1748524409&width=2008"]').attr('alt', 'Tokin Jew banner');

let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;


   
    if ( $('#goog-gt-votingInputSrcLang').length) {
$("img[src*='thumbnail.0000000000_small.jpg']").attr("alt","thumbnail image");  
$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
 $("img.add-to-cart__success").attr("alt","add to cart success");     
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 20) {
        clearInterval(Intervaltime_google);
       
    }
}

$("h5:empty").append("<span style='display:none'>.</span>")
});
